import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Message,
  InputNumber,
  IconButton,
  Icon,
  SelectPicker,
  Cascader,
  InputGroup,
  CheckPicker,
} from 'rsuite'
import { isValidators, requiredFiled, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import classNames from 'classnames'

export default function SearchSubProject({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  onChange,
  onChangeMainProject,
  onChangeSubProject,
  onChangeReportDocuments,
  onChangeInstallment,
  onChangProgressiveReportSet,
  onChangePeriodNo,
  onchangeDateReport,
  disabledValue,
  reportType,
  subProjectOption,
  mainProjectOption,
  installmentOption,
  dateReportOption,
  periodNoOption,
  ...props
}) {
  const { isDeleteError, isError, loading, hideHeader } = props
  const [schema, setSchema] = useState(_schema)
  const [mainProjectDisply, setMainProjectDisply] = useState(true)
  const [subProjectDisply, setSubProjectDisply] = useState(true)
  const [dateReportDisply, setDateReportDisply] = useState(true)
  const [periodNoDisply, setPeriodNoDisply] = useState(true)

  useEffect(() => {
    if (reportType === 'ProgressiveReport' || reportType === 'isCancel') {
      setMainProjectDisply(false)
      setSubProjectDisply(false)
      setDateReportDisply(false)
      setPeriodNoDisply(false)
    }
  }, [reportType, schema, subProjectOption, mainProjectOption, installmentOption, dateReportOption])

  const onChangProgressiveReport = (reportType) => {
    switch (reportType) {
      case 'progressiveReportToThaihealth':
        setMainProjectDisply(true)
        setSubProjectDisply(false)
        setDateReportDisply(true)
        setPeriodNoDisply(false)
        break

      case 'progressiveReportToManager':
        setMainProjectDisply(true)
        setSubProjectDisply(true)
        setDateReportDisply(true)
        setPeriodNoDisply(false)
        break

      case 'progressiveReportByPeriodNo':
        setMainProjectDisply(true)
        setSubProjectDisply(true)
        setDateReportDisply(false)
        setPeriodNoDisply(true)
        break

      default:
        setMainProjectDisply(false)
        setSubProjectDisply(false)
        setDateReportDisply(false)
        setPeriodNoDisply(false)
        break
    }
  }

  return (
    <>
      <Form fluid>
        <Row>
          {schema?.columnDisplay === 'two' ? (
            <>
              {schema?.searchObject?.constYear && schema?.searchObject?.projectDepartment && (
                <>
                  <Row>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {schema.searchObject.constYear.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage error={errors[schema.searchObject.constYear.name]} />
                      <Controller
                        name={schema.searchObject.constYear.name}
                        control={control}
                        defaultValue={schema.searchObject.constYear.value}
                        // rules={isValidators(schema.searchObject.constYear.validators)}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.searchObject.constYear.options}
                              disabled={disabledValue.constYear}
                              value={props.value}
                              block
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                                // onChangeMainProject(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                    >
                      {schema.searchObject.projectDepartment.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage error={errors[schema.searchObject.projectDepartment.name]} />
                      <Controller
                        name={schema.searchObject.projectDepartment.name}
                        control={control}
                        defaultValue={schema.searchObject.projectDepartment.value}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.searchObject.projectDepartment.options}
                              disabled={disabledValue.projectDepartment}
                              value={props.value}
                              block
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                                // onChangeMainProject(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {schema?.searchObject?.projectCode && schema?.searchObject?.projectStatus && (
                <>
                  <Row>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                    >
                      {/* {schema.searchObject.projectCode.label} */}
                      {console.log('vvv ', schema.searchObject.projectCode.validators)}
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(schema.searchObject.projectCode.validators) && 'required'
                        )}
                      >
                        {schema.searchObject.projectCode.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage error={errors[schema.searchObject.projectCode.name]} />
                      <Input
                        name={schema.searchObject.projectCode.name}
                        defaultValue={schema.searchObject.projectCode.value}
                        placeholder={
                          schema.searchObject.projectCode.hint ||
                          `ระบุ${schema.searchObject.projectCode.label}`
                        }
                        disabled={disabledValue.projectCode}
                        // inputRef={register()}
                        inputRef={register(
                          isValidators(schema.searchObject.projectCode.validators)
                        )}
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                    >
                      {schema.searchObject.projectStatus.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage error={errors[schema.searchObject.projectStatus.name]} />
                      <Controller
                        name={schema.searchObject.projectStatus.name}
                        control={control}
                        defaultValue={schema.searchObject.projectStatus.value}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.searchObject.projectStatus.options}
                              disabled={disabledValue.projectStatus}
                              value={props.value}
                              block
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                                // onChangeMainProject(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {schema?.searchObject?.projectReportType && schema?.searchObject?.columns && (
                <>
                  <Row>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                    >
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(schema.searchObject.projectReportType.validators) && 'required'
                        )}
                      >
                        {schema.searchObject.projectReportType.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage error={errors[schema.searchObject.projectReportType.name]} />
                      <Controller
                        name={schema.searchObject.projectReportType.name}
                        control={control}
                        defaultValue={schema.searchObject.projectReportType.value}
                        rules={isValidators(schema.searchObject.projectReportType.validators)}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.searchObject.projectReportType.options}
                              disabled={disabledValue.projectReportType}
                              value={props.value}
                              block
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                                // onChangeMainProject(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                    >
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(schema.searchObject.columns.validators) && 'required'
                        )}
                      >
                        {schema.searchObject.columns.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <ErrorMessage error={errors[schema.searchObject.columns.name]} />

                      <Controller
                        name={schema.searchObject.columns.name}
                        control={control}
                        rules={isValidators(schema.searchObject.columns.validators)}
                        defaultValue={schema.searchObject.columns.options.map((columns) => {
                          const { value } = columns
                          return value
                        })}
                        render={(props) => {
                          return (
                            <CheckPicker
                              sticky
                              data={schema.searchObject.columns.options}
                              defaultValue={schema.searchObject.columns.defaultValue}
                              value={props.value}
                              block
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                                // console.log('x => ', value)
                                // onChangeMainProject(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {schema?.searchObject?.userName && (
                <>
                  <Col
                    lg={2}
                    md={2}
                    sm={4}
                    xs={4}
                    style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                  >
                    {schema.searchObject.userName.label}
                  </Col>
                  <Col lg={10} md={10} sm={20} xs={20} style={{ marginTop: '5px', padding: '8px' }}>
                    <InputGroup inside>
                      <Input
                        name={schema.searchObject.userName.name}
                        defaultValue={schema.searchObject.userName.value}
                        placeholder={
                          schema.searchObject.userName.hint ||
                          `ระบุ${schema.searchObject.userName.label}`
                        }
                        inputRef={register()}
                      />
                      <InputGroup.Button>
                        <Icon icon="search" />
                      </InputGroup.Button>
                    </InputGroup>
                  </Col>
                </>
              )}

              {schema?.searchObject?.statusOption && (
                <>
                  <Col
                    lg={2}
                    md={2}
                    sm={4}
                    xs={4}
                    style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                  >
                    {schema.searchObject.statusOption.label}
                  </Col>
                  <Col lg={10} md={10} sm={20} xs={20} style={{ marginTop: '5px', padding: '8px' }}>
                    <Controller
                      name={schema.searchObject.statusOption.name}
                      control={control}
                      defaultValue={schema.searchObject.statusOption.value}
                      // rules={isValidators(schema.searchObject.statusOption.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={schema.searchObject.statusOption.options}
                            disabled={disabledValue.statusOption}
                            searchable={false}
                            value={props.value}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              // onChangeInstallment(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.firstName && (
                <>
                  <Col
                    lg={2}
                    md={2}
                    sm={24}
                    xs={24}
                    style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                  >
                    {schema.searchObject.firstName.label}
                  </Col>
                  <Col lg={10} md={10} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                    <Input
                      name={schema.searchObject.firstName.name}
                      defaultValue={schema.searchObject.firstName.value}
                      placeholder={
                        schema.searchObject.firstName.hint ||
                        `ระบุ${schema.searchObject.firstName.label}`
                      }
                      inputRef={register()}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.lastName && (
                <>
                  <Col
                    lg={2}
                    md={2}
                    sm={24}
                    xs={24}
                    style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
                  >
                    {schema.searchObject.lastName.label}
                  </Col>
                  <Col lg={10} md={10} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                    <Input
                      name={schema.searchObject.lastName.name}
                      defaultValue={schema.searchObject.lastName.value}
                      placeholder={
                        schema.searchObject.lastName.hint ||
                        `ระบุ${schema.searchObject.lastName.label}`
                      }
                      inputRef={register()}
                    />
                  </Col>
                </>
              )}
            </>
          ) : (
            <>
              {schema?.searchObject?.progressiveReport && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.progressiveReport.validators) && 'required'
                      )}
                    >
                      {schema.searchObject.progressiveReport.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.progressiveReport.name]} />
                    <Controller
                      name={schema.searchObject.progressiveReport.name}
                      control={control}
                      defaultValue={schema.searchObject.progressiveReport.value}
                      rules={isValidators(schema.searchObject.progressiveReport.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={
                              schema.searchObject.progressiveReport.options ||
                              schema.valuesObject.progressive
                            }
                            disabled={disabledValue.progressiveReport}
                            value={props.value}
                            searchable={false}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onChangProgressiveReport(value)
                              onChangProgressiveReportSet(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.reportDocumentsOption && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.reportDocumentsOption.validators) &&
                          'required'
                      )}
                    >
                      {schema.searchObject.reportDocumentsOption.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.reportDocumentsOption.name]} />
                    <Controller
                      name={schema.searchObject.reportDocumentsOption.name}
                      control={control}
                      defaultValue={schema.searchObject.reportDocumentsOption.value}
                      rules={isValidators(schema.searchObject.reportDocumentsOption.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={
                              schema.searchObject.reportDocumentsOption.options ||
                              schema.valuesObject.reportDocuments
                            }
                            disabled={disabledValue.reportDocumentsOption}
                            value={props.value}
                            searchable={false}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onChangeReportDocuments(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.mainProjectOption && mainProjectDisply && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.mainProjectOption.validators) && 'required'
                      )}
                    >
                      {schema.searchObject.mainProjectOption.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.mainProjectOption.name]} />
                    <Controller
                      name={schema.searchObject.mainProjectOption.name}
                      control={control}
                      defaultValue={schema.searchObject.mainProjectOption.value}
                      rules={isValidators(schema.searchObject.mainProjectOption.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={
                              schema.searchObject.mainProjectOption.options ||
                              schema.valuesObject.mainProject ||
                              mainProjectOption
                            }
                            disabled={disabledValue.mainProjectOption}
                            value={props.value}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onChangeMainProject(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.subProjectOption && subProjectDisply && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.subProjectOption.validators) && 'required'
                      )}
                    >
                      {schema.searchObject.subProjectOption.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.subProjectOption.name]} />
                    <Controller
                      name={schema.searchObject.subProjectOption.name}
                      control={control}
                      defaultValue={schema.searchObject.subProjectOption.value}
                      rules={isValidators(schema.searchObject.subProjectOption.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={schema.searchObject.subProjectOption.options || subProjectOption}
                            disabled={disabledValue.subProjectOption}
                            value={props.value}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onChangeSubProject(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.witness && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel>
                      {requiredFiled(
                        schema.searchObject.witness.validators,
                        schema.searchObject.witness.label
                      )}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.witness.name]} />
                    <Input
                      name={schema.searchObject.witness.name}
                      defaultValue={schema.searchObject.witness.value}
                      placeholder={
                        schema.searchObject.witness.hint ||
                        `ระบุ${schema.searchObject.witness.label}`
                      }
                      disabled={disabledValue.witness}
                      inputRef={register(isValidators(schema.searchObject.witness.validators))}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.installment && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.installment.validators) && 'required'
                      )}
                    >
                      {schema.searchObject.installment.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.installment.name]} />
                    <Controller
                      name={schema.searchObject.installment.name}
                      control={control}
                      defaultValue={schema.searchObject.installment.value}
                      rules={isValidators(schema.searchObject.installment.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={schema.searchObject.installment.options || installmentOption}
                            disabled={disabledValue.installment}
                            value={props.value}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onChangeInstallment(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.dateReportOption && dateReportDisply && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.dateReportOption.validators) && 'required'
                      )}
                    >
                      {schema.searchObject.dateReportOption.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.dateReportOption.name]} />
                    <Controller
                      name={schema.searchObject.dateReportOption.name}
                      control={control}
                      defaultValue={schema.searchObject.dateReportOption.value}
                      rules={isValidators(schema.searchObject.dateReportOption.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={schema.searchObject.dateReportOption.options || dateReportOption}
                            disabled={disabledValue.dateReportOption}
                            value={props.value}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onchangeDateReport(value)
                              // onChangeInstallment(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}

              {schema?.searchObject?.periodNoOption && periodNoDisply && (
                <>
                  <Col lg={4} md={6} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.searchObject.periodNoOption.validators) && 'required'
                      )}
                    >
                      {schema.searchObject.periodNoOption.label}
                    </ControlLabel>
                  </Col>
                  <Col lg={20} md={18} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                    <ErrorMessage error={errors[schema.searchObject.periodNoOption.name]} />
                    <Controller
                      name={schema.searchObject.periodNoOption.name}
                      control={control}
                      defaultValue={schema.searchObject.periodNoOption.value}
                      rules={isValidators(schema.searchObject.periodNoOption.validators)}
                      render={(props) => {
                        return (
                          <SelectPicker
                            data={schema.searchObject.periodNoOption.options || periodNoOption}
                            disabled={disabledValue.periodNoOption}
                            value={props.value}
                            block
                            placeholder="เลือก"
                            onChange={(value) => {
                              props.onChange(value)
                              onChangePeriodNo(value)
                              // onChangeInstallment(value)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}
            </>
          )}
        </Row>
      </Form>
    </>
  )
}
